(function ($, Drupal) {
  Drupal.behaviors.faqBlock = {
    attach(context) {
      const slideTime = 300; // ms.
      let mediaChangedAfterPageLoaded = false;

      /**
       * Detect if element is in viewport.
       * @param {object} elm - element which must be checked.
       * @param {number} addOffset - additional offset.
       * @return {boolean} true if the element is above the viewport.
       */
      const isAboveViewport = (elm, addOffset) => {
        const elementTop = elm.offset().top;
        const viewportTop = $(window).scrollTop();

        return (elementTop - addOffset) > viewportTop;
      };

      /**
       * Get the visible height of an element.
       * @param {object} element - element selector which Height is needed.
       * @return {number} The visible vertical part of an element.
       */
      const getVisibleHeight = (element) => {
        const elH = element.outerHeight();
        const H = $(window).height();
        const r = element[0].getBoundingClientRect();
        const t = r.top - (window.innerHeight - H);
        const b = r.bottom;

        return Math.max(0, t > 0 ? Math.min(elH, H - t) : Math.min(b, H));
      };

      /**
       * Prevent overlapping by header wrapper.
       */
      const hideHeaderWrapper = () => {
        $('header.header > .header__wrapper').addClass('visually-hidden');
        setTimeout(() => {
          $('body').addClass('is_hidden');
        }, slideTime + 100);
        setTimeout(() => {
          $('header.header > .header__wrapper').removeClass('visually-hidden');
        }, slideTime + 450);
      };

      /**
       * If element is partially hidden under the viewport - scroll the page a bit up.
       * @param {object} element - element selector which is checked.
       * @param {number} gapFromBottom - value to scroll the page up.
       * @param {number} speed - after this value+ delay scroll the page with this value speed.
       */
      const scrollPageUp = (element, gapFromBottom = 150, speed) => {
        setTimeout(() => {
          if (getVisibleHeight(element) < element.outerHeight(true)) {
            $('html, body').animate({
              scrollTop: $(window).scrollTop() + gapFromBottom,
            }, speed);
          }
        }, speed + 10);
      };

      $('.faq-iblock', context).once().each((ind, elem) => {
        const $faqContentWrapper = $(elem).find('.faq-iblock__split_content__wrapper');

        $(elem).find('.faq_section__heading').on('click keypress', (event) => {
          if (event.type === 'click' || event.which === 13) { // click or enter keypress.
            const $this = $(event.currentTarget);
            const $thisSection = $this.closest('.faq-section');
            const thisSectionInd = $thisSection.index();
            let openedAboveSectionContentH = 0;
            let $activeHeading;
            let activeHeadingH = 0;
            let inactiveHeadingH = 0;
            let diffHeadingHeights = 0; // difference between the active and inactive header heights.

            // Detect active (expanded) section above the current one:
            if ($(elem).find(`.faq_section__heading.active`).closest('.faq-section').index() < thisSectionInd) {
              $activeHeading = $(elem).find('.faq_item__heading.active');
              openedAboveSectionContentH = $(elem).find('.faq_section__heading.active + .faq-section__data').outerHeight(true) || 0;
              activeHeadingH = $activeHeading.outerHeight(true) || 0;
              inactiveHeadingH = $(elem).find('.faq_item__heading.active ~ .heading-helper').outerHeight(true) || 0;
              diffHeadingHeights = activeHeadingH - inactiveHeadingH;
            }

            const heightForCollapse = openedAboveSectionContentH + diffHeadingHeights;

            if ($(window).width() < 768) {
              if ($(elem).find('.faq_item__heading.active').length) {
                $(elem).find('.faq_item__heading').removeClass('last-active');
                $(elem).find('.faq_item__heading.active').addClass('last-active'); // helps to show active mark on desktop after removing ".active" on mobile.
              }

              $(elem).find('.faq_item__heading').removeClass('active');
              $(elem).find('.faq-item__data').slideUp(slideTime);
            }

            if ($this.hasClass('active')) {
              $(elem).find('.faq_section__heading').removeClass('active');
              $(elem).find('.faq-section__data').slideUp(slideTime);
            }
            else {
              $(elem).find('.faq_section__heading').removeClass('active');
              $(elem).find('.faq-section__data').slideUp(slideTime);
              $this.addClass('active');
              $this.next('.faq-section__data').slideDown(slideTime);
            }

            if ($(window).width() < 768) {
              // If the element will be moved out of the viewport after another item/section collapsed -
              // Scroll to element's pos. = pos. before other items collapsed:
              if (!isAboveViewport($this, heightForCollapse)) {
                if ($(window).scrollTop() > heightForCollapse) { // check if the diff. value is positive for scrollTop.
                  $('html, body').animate({
                    scrollTop: $(window).scrollTop() - openedAboveSectionContentH,
                  }, slideTime);

                  const compensatorClassName = 'faq-section--compensate-heading-diff-heights';
                  // $activeHeading - is active heading before the current became active:
                  if ($activeHeading) {
                    $activeHeading.prepend(`<div class="${compensatorClassName}" style="height: ${diffHeadingHeights}px"></div>`);
                    $activeHeading.find(`.${compensatorClassName}`).slideUp(slideTime);
                    setTimeout(() => {
                      $activeHeading.find(`.${compensatorClassName}`).remove();
                    }, slideTime);
                  }
                }
              }

              // If current heading after became active is partially hidden under the viewport -
              // scroll the page a bit up (gapFromBottom value):
              scrollPageUp($this, 150, slideTime);

              hideHeaderWrapper();
            }

            $this.blur(); // undo focus state;
          }
        });

        $(elem).find('.faq_item__heading').on('click keypress', (event) => {
          if (event.type === 'click' || event.which === 13) { // click or enter keypress.
            const $this = $(event.currentTarget);
            const titleText = $this.text();
            const $content = $this.next('.faq-item__data');
            const contentHtml = $content.html();
            const $thisSection = $this.closest('.faq-section');
            const $thisSectionActiveHeading = $thisSection.find('.faq_item__heading.active');
            const thisItemInd = $this.closest('.faq-item').index();
            let openedAboveItemContentH = 0;
            let activeHeadingH = 0;
            let inactiveHeadingH = 0;
            let diffHeadingHeights = 0; // difference between the active and inactive header heights.

            // Detect active (expanded) item above the current one (the same section):
            if ($thisSectionActiveHeading.closest('.faq-item').index() < thisItemInd) {
              openedAboveItemContentH = $thisSectionActiveHeading.next('.faq-item__data').outerHeight(true) || 0;
              activeHeadingH = $thisSectionActiveHeading.outerHeight(true) || 0;
              inactiveHeadingH = $thisSection.find('.faq_item__heading.active ~ .heading-helper').outerHeight(true) || 0;
              diffHeadingHeights = activeHeadingH - inactiveHeadingH;
            }

            const heightForCollapse = openedAboveItemContentH + diffHeadingHeights;

            if (!$this.hasClass('active')) {
              $faqContentWrapper.find('.faq-question').html(titleText);
              $faqContentWrapper.find('.faq-answer').html(contentHtml);
            }

            if ($(window).width() < 768) {
              $(elem).find('.faq_item__heading').removeClass('last-active');
              $this.addClass('last-active'); // helps to show active mark on desktop after removing ".active" on mobile.

              if ($this.hasClass('active')) {
                $(elem).find('.faq_item__heading').removeClass('active');
                $(elem).find('.faq-item__data').slideUp(slideTime);
              } else {
                $(elem).find('.faq_item__heading').removeClass('active');
                $(elem).find('.faq-item__data').slideUp(slideTime);
                $this.addClass('active');
                $content.slideDown(slideTime);
              }

              // If the element will be moved out of the viewport after another item/section collapsed -
              // scroll to element's pos. = pos. before other items collapsed:
              if (!isAboveViewport($this, heightForCollapse)) {
                if ($(window).scrollTop() > heightForCollapse) { // check if the diff. value is positive for scrollTop.
                  $('html, body').animate({
                    scrollTop: $(window).scrollTop() - heightForCollapse,
                  }, slideTime);

                  const compensatorClassName = 'faq-item--compensate-heading-diff-heights';
                  // $thisSectionActiveHeading - is active heading before the current became active:
                  $thisSectionActiveHeading.prepend(`<div class="${compensatorClassName}" style="height: ${diffHeadingHeights}px"></div>`);
                  $thisSectionActiveHeading.find(`.${compensatorClassName}`).slideUp(slideTime);
                  setTimeout(() => {
                    $thisSectionActiveHeading.find(`.${compensatorClassName}`).remove();
                  }, slideTime);
                }
              }

              // If current heading after became active is partially hidden under the viewport -
              // scroll the page a bit up (gapFromBottom value):
              scrollPageUp($this, 150, slideTime);

              hideHeaderWrapper();
            } else {
              $(elem).find('.faq_item__heading').removeClass('active last-active');
              $this.addClass('active');
            }

            $this.blur(); // undo focus state;
          }
        });

        // Init:
        // Make headings available for "Tab" nav.
        $(elem).find('.faq_section__heading, .faq_item__heading').attr('tabindex', 0);

        // Make 1st items active.
        if ($(window).width() >= 768) {
          $(elem).find('.faq_section__heading').first().trigger('click');
          $(elem).find('.faq_item__heading').first().trigger('click');
        }

        $(window).on('resize', () => {
          if ($(window).width() >= 768) {
            if (!$(elem).find('.faq_item__heading.active').length && !$(elem).find('.faq_item__heading.last-active').length) {
              // Make 1st items active.
              $(elem).find('.faq_section__heading').first().trigger('click');
              $(elem).find('.faq_item__heading').first().trigger('click');
            }
          } else {
            // Only once, after changing media breakpoint to mobile - close expanded section:
            if ($(elem).find('.faq_section__heading.active').length && mediaChangedAfterPageLoaded === false) {
              $(elem).find('.faq_section__heading.active').trigger('click');
              mediaChangedAfterPageLoaded = true;
            }
          }
        });
      });
    },
  };
}(jQuery, Drupal));
